/**
 * FilterPill — visual indicator that the page is filtered by a URL query.
 * Includes a built-in "Clear" link that strips ALL search params from the URL.
 *
 * Usage:
 *   <FilterPill label="Today only" testId="filter-today"/>
 */
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";

export function FilterPill({ label, testId, tone = "indigo" }) {
    const loc = useLocation();
    const toneCls = {
        indigo:  "border-primary/40 text-primary bg-primary/5",
        emerald: "border-emerald-500/40 text-emerald-600 bg-emerald-500/5",
        warning: "border-amber-500/40 text-amber-600 bg-amber-500/5",
        danger:  "border-rose-500/40 text-rose-600 bg-rose-500/5",
    }[tone] || "border-primary/40 text-primary bg-primary/5";
    return (
        <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border text-[11px] uppercase tracking-[0.12em] ${toneCls}`}
             data-testid={testId}>
            <span>{label}</span>
            <Link to={loc.pathname} data-testid={`${testId}-clear`} aria-label="Clear filter"
                  className="hover:opacity-70 inline-flex items-center">
                <X className="w-3 h-3"/>
            </Link>
        </div>
    );
}

export default FilterPill;
